// import React from 'react';
// import styled, { keyframes, css } from 'styled-components';
// // Alternative approach using require
// // const logoImage = require('../../assets/logo.jpg').default;

// // Define the animation
// const scroll = keyframes`
//   0% { transform: translateX(0); }
//   100% { transform: translateX(calc(-250px * 2))}
// `;

// // Create the white gradient mixin as a styled-component
// const whiteGradient = css`
//   background: linear-gradient(to right, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%);
// `;

// // Styled components
// const SliderSection = styled.section`
//   padding: 40px 0;
//   background-color: #f8f9fa;
// `;

// const HeaderContainer = styled.div`
//   text-align: center;
//   margin-bottom: 30px;
// `;

// const MainHeader = styled.h2`
//   font-size: 2rem;
//   color: #1a237e;
//   margin-bottom: 10px;
  
//   @media (max-width: 768px) {
//     font-size: 1.5rem;
//   }
// `;

// const SubHeader = styled.p`
//   font-size: 1.1rem;
//   color: #666;
//   margin-bottom: 20px;
  
//   @media (max-width: 768px) {
//     font-size: 1rem;
//   }
// `;

// const SliderContainer = styled.div`
//   background: white;
//   box-shadow: 0 10px 20px -5px rgba(0, 0, 0, .125);
//   height: 100px;
//   margin: auto;
//   overflow: hidden;
//   position: relative;
//   width: 960px;
  
//   @media (max-width: 1024px) {
//     width: 90%;
//     max-width: 960px;
//   }
  
//   @media (max-width: 768px) {
//     width: 100vw;
//     height: 80px;
//   }
  
//   @media (max-width: 480px) {
//     height: 70px;
//   }
  
//   &::before,
//   &::after {
//     ${whiteGradient}
//     content: "";
//     height: 100px;
//     position: absolute;
//     width: 200px;
//     z-index: 2;
    
//     @media (max-width: 768px) {
//       height: 80px;
//       width: 100px;
//     }
    
//     @media (max-width: 480px) {
//       height: 70px;
//       width: 80px;
//     }
//   }
  
//   &::after {
//     right: 0;
//     top: 0;
//     transform: rotateZ(180deg);
//   }

//   &::before {
//     left: 0;
//     top: 0;
//   }
// `;

// const SlideTrack = styled.div`
//   animation: ${scroll} ${props => props.animationSpeed || '30s'} linear infinite;
//   display: flex;
//   width: calc(250px * 4); /* Adjusted for 2 images doubled */
  
//   @media (max-width: 768px) {
//     width: calc(200px * 4);
//   }
  
//   @media (max-width: 480px) {
//     width: calc(150px * 4);
//   }
// `;

// const Slide = styled.div`
//   height: 100px;
//   width: 250px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
  
//   @media (max-width: 768px) {
//     height: 80px;
//     width: 200px;
//   }
  
//   @media (max-width: 480px) {
//     height: 70px;
//     width: 150px;
//   }
// `;

// const LogoImage = styled.img`
//   max-height: 80px;
//   max-width: 200px;
//   object-fit: contain;
  
//   @media (max-width: 768px) {
//     max-height: 60px;
//     max-width: 160px;
//   }
  
//   @media (max-width: 480px) {
//     max-height: 50px;
//     max-width: 120px;
//   }
// `;

// const SMCLabel = styled.div`
//   font-size: 24px;
//   font-weight: bold;
//   color: #2596be; /* Logo color - adjust as needed */
//   margin-left: 10px;
  
//   @media (max-width: 768px) {
//     font-size: 20px;
//     margin-left: 8px;
//   }
  
//   @media (max-width: 480px) {
//     font-size: 16px;
//     margin-left: 5px;
//   }
// `;

// const InfiniteSlider = ({ 
//   animationSpeed = "30s",
//   infoTitle = "About Our Company",
//   infoSubtitle = "Learn more about our services and expertise",
//   clientsTitle = "Our Trusted Clients",
//   clientsSubtitle = "Partnering with industry leaders worldwide"
// }) => {
//   // Define the specific images
//   const images = [
//     { 
//       src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQDkh975X1VAjCHA7epvvP9rvroaxV_rm71lg&s", 
//       alt: "Client Logo 1" 
//     },
//     { 
//       // Using public folder approach
//       src: './logo.jpg', 
//       alt: "SMC Logo",
//       showLabel: true
//     }
//   ];
  
//   // Double the images array to create the infinite effect
//   const doubledImages = [...images, ...images];
  
//   return (
//     <SliderSection>
//       {/* Slider */}
//       <SliderContainer>
//         <SlideTrack animationSpeed={animationSpeed}>
//           {doubledImages.map((image, index)  => (
//             <Slide key={index}>
//               <LogoImage 
//                 src={image.src} 
//                 alt={image.alt || ''} 
//               />
//               {image.showLabel && <SMCLabel>SMC</SMCLabel>}
//             </Slide>
//           ))}
//         </SlideTrack>
//       </SliderContainer>
//     </SliderSection>
//   );
// };

// export default InfiniteSlider;

                                 

// import React from 'react';                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  
// import styled from 'styled-components';

// // Styled components
// const SliderSection = styled.section`
//   padding: 40px 0;
//   background-color: #f8f9fa;
// `;

// const StaticImagesContainer = styled.div`
//   background: white;
//   box-shadow: 0 10px 20px -5px rgba(0, 0, 0, .125);
//   margin: auto;                                                                                     
//   position: relative;
//   width: 960px;
//   display: flex;
//   justify-content: center;
//   gap: 40px;
//   padding: 20px 0;
  
//   @media (max-width: 1024px) {
//     width: 90%;
//     max-width: 960px;
//   }
  
//   @media (max-width: 800px) {
//     width: 100vh;
//     gap: 20px;
//     padding: 15px 0;
//   }
  
//   @media (max-width: 480px) {
//     flex-direction: column;
//     align-items: center;
//     gap: 30px;
//     margin:1rem 0px
//     padding: 20px 0;
//     justify-content: space-between;
//     align-items: space-between;

//   }
// `;

// const ImageContainer = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: center;
 
// `;

// const LogoImage = styled.img`
//   max-height: 80px;
//   max-width: 200px;
//   object-fit: contain;
  
//   @media (max-width: 768px) {
//     max-height: 60px;
//     max-width: 160px;
//   }
  
//   @media (max-width: 480px) {
//     max-height: 50px;
//     max-width: 120px;
//   }
// `;

// const SMCLabel = styled.div`
//   font-size: 24px;
//   font-weight: bold;
//   color: #2596be; /* Logo color - adjust as needed */
//   margin-left: 10px;
  
//   @media (max-width: 768px) {
//     font-size: 20px;
//     margin-left: 8px;
//   }
  
//   @media (max-width: 480px) {
//     font-size: 16px;
//     margin-left: 5px;
//   }
// `;

// // Import approach for local images
// const StaticImageSlider = ({ 
//   image1Src = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQDkh975X1VAjCHA7epvvP9rvroaxV_rm71lg&s",
//   image1Alt = "Client Logo 1",
//   image2Src = "./logo.jpg",
//   image2Alt = "SMC Logo",
//   showLabel = true
// }) => {
//   // Define the static images with props for customization
//   const images = [
//     { 
//       src: image1Src, 
//       alt: image1Alt,
//       showLabel: false
//     },
//     { 
//       src: image2Src, 
//       alt: image2Alt,
//       showLabel: showLabel
//     }
//   ];
  
//   return (
//     <SliderSection>
//       <StaticImagesContainer>
//         {images.map((image, index) => (
//           <ImageContainer key={index}>
//             <LogoImage 
//               src={image.src} 
//               alt={image.alt || ''} 
//             />
//             {image.showLabel && <SMCLabel>SMC</SMCLabel>}
//           </ImageContainer>
//         ))}
//       </StaticImagesContainer>
//     </SliderSection>
//   );
// };

// export default StaticImageSlider;



import React from 'react';
import './InfiniteSlider.css';

const StaticImageSlider = ({ 
  image1Src = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQDkh975X1VAjCHA7epvvP9rvroaxV_rm71lg&s",
  image1Alt = "Client Logo 1",
  image2Src = "./logo.jpg",
  image2Alt = "SMC Logo",
  image3Src = "./illinoistoolworks.jpeg",
  image3Alt = "illinoistoolworks",
  image4Src ="./bisslogo.jpg", 
  image4Alt = "BISS LOGO",
  showLabel = true
}) => {
  const images = [
    { 
      src: image2Src, 
      alt: image2Alt,
      showLabel: true
    },
    { 
      src: image1Src, 
      alt: image1Alt,
      showLabel: false
    }
    ,
    { 
      src: image3Src, 
      alt: image3Alt,
      showLabel: false
    }
    ,
    { 
      src: image4Src, 
      alt: image4Alt,
      showLabel: false
    }
  ];
  
  return (
    <section className="slider-section">
      <div className="static-images-container">
        {images.map((image, index) => (
          <div className="image-container" key={index}>
            {image.alt == "BISS LOGO" ?
             <img 
              
              style={{height:"7rem", width:"7rem"}}
              src={image.src} 
              alt={image.alt || ''} 
            /> 
             :
              <img 
              className="logo-image"
              src={image.src} 
              alt={image.alt || ''} 
            />
            }
            {image.showLabel && <div className="smc-label">SMC</div>}
          </div>
        ))}
      </div>
    </section>
  );
};

export default StaticImageSlider;